//#region src/metadata/lang.ts
const createLang = () => {
	return (pageContext) => {
		return pageContext.localeId;
	};
};
//#endregion
export { createLang };

//# sourceMappingURL=lang.js.map